import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class BlockTestimony {
	static init() {

		let container = document.querySelector(".block-testimony-container");

		if (!container) {
			return;
		}

		let section = container.closest('.section');
		let cols = document.querySelectorAll('.testimony-cols');

		if( cols.length === 0 ){
			return;
		}

		let mm = gsap.matchMedia();

		mm.add("(min-width: 768px)", () => {

			let max = Math.max(cols[0].offsetHeight, cols[1].offsetHeight);

			if (max > container.offsetHeight && !ScrollTrigger.isTouch) {

				ScrollTrigger.create({
					trigger: section,
					pin: true,
					start: "center center",
					end: "+=" + max
				});

			}


			if (cols[0].offsetHeight > container.offsetHeight) {
				// col gauche
				gsap.set(cols[0], {
					y: container.offsetHeight - cols[0].offsetHeight
				});

				gsap.to(cols[0], {
					y: 0,
					scrollTrigger: {
						trigger: container,
						start: "center center",
						end: "+=" + max,
						scrub: 1
					}
				});
			}

			if (cols[1].offsetHeight > container.offsetHeight) {
				gsap.to(cols[1], {
					y: container.offsetHeight - cols[1].offsetHeight,
					scrollTrigger: {
						trigger: container,
						start: "center center",
						end: "+=" + max,
						scrub: 1
					}
				});
			}

		});

		mm.add("(max-width: 767px)", () => {
			const swiper = container.querySelector('.swiper');
			const prev = container.querySelector(".swiper-navigation-button-prev");
			const next = container.querySelector(".swiper-navigation-button-next");
			new Swiper(swiper, {
				slidesPerView: 1,
				grabCursor: true,
				spaceBetween: 20,
				navigation: {
					prevEl: prev,
					nextEl: next
				}
			});
		});

	}
}
